<template>
    <div>
        <div class="title">
            <h4 class="mb-0">Subscriptions</h4>
        </div>
        <div>
            <table class="table list">
                <thead>
                    <tr>
                        <th>Date:</th>
                        <th>List of Products:</th>
                        <th>Subscription Number:</th>
                        <th>Rate:</th>
                    </tr>
                </thead>
                <tbody v-if="billings && billings.length">
                    <template v-for="(billing, index) in billings">
                        <tr :key="'row-' + index">
                            <td>{{ getBillingDate(billing) }}</td>
                            <td>{{ billing.subscriptions_products }}</td>
                            <td>{{ billing.subscriptions_number }}</td>
                            <td>{{ billing.subscriptions_mrr }}</td>
                        </tr>
                    </template>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td :colspan="9">
                            <i>No records available</i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        billings: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {};
    },
    methods: {
        getBillingDate(billing) {
            return this._carbonDateDisplay(billing.subscriptions_date);
        }
    }
};
</script>

<style scoped></style>
